<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="user-manager-tab">
	<div>
		<span jhiTranslate="site-admin.user.pane.title"></span>
		<span jhiTranslate="site-admin.user.pane.comment"></span>
	</div>
	<br/>
	<jhi-column-filter [request]="request"
					   [filters]="filters"></jhi-column-filter>
    <div class="row pb-3 pt-3">
        <div class="col d-flex justify-content-end">
            <button class="btn btn-outline-info" (click)="addUser()"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i> <span style="margin-left: 5px;" jhiTranslate="site-admin.user.add"></span></button>
        </div>
    </div>
	<div class="table-responsive" *ngIf="users">
		<table class="table table-striped table-bordered table-curved" *ngIf="users.length else nodata">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th [jhiSortBy]="ColumnLabels.USER_NAME"><span jhiTranslate="site-admin.user.columns.user-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.FIRST_NAME"><span jhiTranslate="site-admin.user.columns.first-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.LAST_NAME"><span jhiTranslate="site-admin.user.columns.last-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.EMAIL"><span jhiTranslate="site-admin.user.columns.email"></span> <span class="fa fa-sort"></span></th>
				<th><span jhiTranslate="site-admin.user.columns.crop"></span></th>
				<th><span jhiTranslate="site-admin.user.columns.Roles"></span></th>
				<th [jhiSortBy]="ColumnLabels.STATUS"><span jhiTranslate="site-admin.user.columns.status"></span> <span class="fa fa-sort"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let user of users; trackBy: trackId; index as index">
				<td *ngIf="hasSuperAdminRole(user.userRoles)"> {{user.username}} </td>
				<td *ngIf="!hasSuperAdminRole(user.userRoles)">
					<a href="javascript:void(0)" (click)="editUser(user)"> {{user.username}} </a>
				</td>
				<td>{{user.firstName}}</td>
				<td>{{user.lastName}}</td>
				<td>{{user.email}}</td>
				<td>
					<span *ngIf="user.crops?.length === (crops | async)?.length" class="site-admin-badge" jhiTranslate="site-admin.all-crops"></span>
					<span *ngIf="user.crops?.length !== (crops | async)?.length && user.crops?.length > 0">
                <span *ngIf="user.crops[0]" class="site-admin-badge">{{user.crops[0].cropName}}</span>
                <span *ngIf="user.crops?.length > 1"
					  [title]="getCropsTitleFormat(user.crops)"
					  style="padding-left: 5px; color: #428bca;"> and {{user.crops?.length - 1}} more</span>
				</span>
				</td>
				<td>
             	<span *ngIf="(user.userRoles | dedupRoleNames)">
                	<span *ngIf="(user.userRoles | dedupRoleNames)[0]" class="site-admin-badge">{{(user.userRoles | dedupRoleNames)[0]}}</span>
                	<span *ngIf="(user.userRoles | dedupRoleNames).length > 1" [title]="getRoleNamesTitleFormat((user.userRoles))"
					  style="padding-left: 5px; color: #428bca;"> and {{(user.userRoles | dedupRoleNames).length - 1}} more</span>
                </span>
				</td>
				<td *ngIf="hasSuperAdminRole(user.userRoles)">
					<span *ngIf="user.active === true" jhiTranslate="site-admin.active"></span>
					<span *ngIf="user.active === false" jhiTranslate="site-admin.inactive"></span>
				</td>
				<td *ngIf="!hasSuperAdminRole(user.userRoles)">
					<a href="javascript:void(0)" *ngIf="user.active === true" (click)="showUserStatusConfirmPopUp(user)"> <span jhiTranslate="site-admin.deactivate"></span></a>
					<a href="javascript:void(0)" *ngIf="user.active === false" (click)="showUserStatusConfirmPopUp(user)"> <span jhiTranslate="site-admin.activate"></span></a>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="users && users.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
